import axios, {AxiosResponse, InternalAxiosRequestConfig} from 'axios';
import {store} from '../redux/store';
import {api, baseUrl} from './api';
import {endSession} from '../screens/auth/login/actions';
import {Platform} from 'react-native';
import {crashlyticsService} from '../utils/services/crashlytics';
import {BaseApiResponse} from '../interfaces/api/baseApiResponse';

/**
 * create new axios instance.
 * @type {AxiosInstance}
 */
const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0',
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Device-OS': Platform.OS,
  },
});

axiosInstance.defaults.timeout = 30000;
axiosInstance.defaults.timeoutErrorMessage = 'timeout';
/**
 * create interceptor for request to add token.
 */
axiosInstance.interceptors.request.use(
  async (config: InternalAxiosRequestConfig<any>) => {
    const tempConfig = {...config};

    const {currentUser} = store.getState().auth || {};
    const {language} = store.getState().lang || {};
    let languageCode = 'en';
    if (language?.languageCode) {
      languageCode = language.languageCode;
    }
    tempConfig.headers['Accept-Language'] = languageCode;
    if (currentUser?.token) {
      tempConfig.headers.Authorization = `Bearer ${currentUser.token}`;
    }
    return tempConfig;
  },
  (error: any) => {
    crashlyticsService.recordError(error);
    return Promise.reject(error);
  },
);
/**
 * create axios interceptor to response for refresh token.
 */
axiosInstance.interceptors.response.use(
  async (response: AxiosResponse<BaseApiResponse, any>) => {
    return response;
  },
  async (error: any) => {
    if (error?.response?.status === 401) {
      await endSession();
    }
    return Promise.reject(
      error?.response?.data?.error_description || error?.response?.message,
    );
  },
);

export default axiosInstance;
